<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-积分管理-积分明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderNo" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.createTime" type="daterange" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-select size="small" v-model="formInline.payStatus" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="已支付" value="20"></el-option>
            <el-option label="未支付" value="10"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="orderNo" align="center" label="订单号"></el-table-column>
          <el-table-column prop="user.nickName" align="center" label="昵称"></el-table-column>
          <el-table-column prop="user.mobile" align="center" label="用户手机号"></el-table-column>
          <el-table-column prop="day" align="center" label="会员天数">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.day <= 30 ? 'orange' : (scope.row.day <= 365 ? '#409eff' : 'red') }">
                {{ scope.row.day }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="param.marketPrice" align="center" label="会员价格">
            <template slot-scope="scope">
              <span style="color:#1aad19">￥{{scope.row.param.marketPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="param.price" align="center" label="会员实际购买价">
            <template slot-scope="scope">
              <span style="color:#409eff">￥{{scope.row.param.price}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payPrice" align="center" label="实际支付金额">
            <template slot-scope="scope">
              <span style="color:red">￥{{scope.row.payPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款状态" align="center">
            <template slot-scope="scope">
              <span style="color:red" v-if="scope.row.payStatus == 10">未支付</span>
              <span style="color:green" v-if="scope.row.payStatus == 20">已支付</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
          <el-table-column prop="payTime" align="center" label="支付时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import PlanApi from "@/api/plan.js";
export default {
  components: {},
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        createTime: "",
        orderNo: "",
        payStatus: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      PlanApi.Viplog(Params, true)
        .then(data => {
          self.loading = false;
          if(data.data.data){
            data.data.data.forEach(element => {
              element.param=JSON.parse(element.param);
            });
          }
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.getTableList();
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/cash/plan/membership.vue